import React from 'react';
import { Link } from 'react-router-dom';
import { TextInput, FormField } from 'evergreen-ui';
import { createForm, useForm } from 'effector-forms';

import { styled } from 'linaria/react';
import surprise from 'src/assets/surprise.png';
import mail from 'src/assets/mail.png';
import key from 'src/assets/key.png';

import { routes } from 'src/routes';
import { getTokenFx } from 'src/store/auth.store';

import { AuthForm, AuthContainer, AuthFormTitle, AuthHint, AuthButton, ForgotLink } from 'src/features/auth/ui/components';

const Surprise = styled.div`
	text-align: center;
  margin-bottom: 20px;

	img {
		max-width: 100px;
	}
`;
const Icon = styled.span`
	img {
		max-width: 16px;
    opacity: .3;
    margin-right: -28px;
    filter: invert(1);
	}
`;

export const loginForm = createForm({
	fields: {
		email: {
			init: '',
		},
		password: {
			init: '',
		},
	},
});

export const LoginPage = () => {
	const form = useForm(loginForm);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		await getTokenFx(form.values);
	};

	return (
		<AuthContainer>
			<AuthForm onSubmit={handleSubmit}>
				<Surprise>
					<img src={surprise} alt=""/>
				</Surprise>
				<AuthFormTitle>Sign in</AuthFormTitle>
				<FormField
					style={{ marginTop: 10, marginLeft: 15, marginRight: -15 }}
					className={'inputstyle-auth'}
				>
					<Icon>
						<img src={mail} alt=""/>
					</Icon>
					<TextInput
						required
						value={form.fields.email.value}
						placeholder={'E-mail'}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.email.onChange(e.target.value)}
						width={'100%'}
						type={'email'}
					/>
				</FormField>
				<FormField
					style={{ marginTop: 10, marginLeft: 15, marginRight: -15 }}
					hint={
						<Link to={routes.root.auth.forgot.path}>
							<ForgotLink tabIndex={-1}>Forgot password?</ForgotLink>
						</Link>
					}
					className={'inputstyle-auth'}
				>
					<Icon>
						<img src={key} alt=""/>
					</Icon>
					<TextInput
						required
						width={'100%'}
						type={'password'}
						placeholder={'Password'}
						value={form.fields.password.value}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.password.onChange(e.target.value)}

					/>
				</FormField>
				<AuthButton>
					Continue
				</AuthButton>
				<AuthHint>
					New to Boxes? <Link to={routes.root.auth.registration.path}>Sign up here</Link>
				</AuthHint>
			</AuthForm>
		</AuthContainer>
	);
};
